import React from "react";
import "./Sidebar.css";
import Steps from "../FormSteps/Steps";
import xenonifyAiLogo from "../../assets/xenonify-white-logo.svg";
export default function BookDemoSidebar({ step }) {
  return (
    <div className="sidebar-wrapper">
      <div className="sidebar-content">
        <img src={xenonifyAiLogo} alt="xenonify-logo" />
        <h1>Book Demo</h1>
        <p>Book a time to chat 1:1 with a Xenonify team member. </p>
      </div>
      <Steps step={step} />
    </div>
  );
}
